<template>
  <div class="container-fluid content-pad content-pad--big-top">
    <div class="content-wrap-x-small">
      <dx-progressbar
        :steps="4"
        :active-step="2"
        is-interactive
        @jump-to-step="jumpToStep"
      />
    </div>
    <div class="row mt-5">
      <div class="col-12 col-md-8">
        <h3>{{ $t('offer.data.headline') }}</h3>
        <p>{{ $t('offer.data.sub') }}</p>

        <dx-policy-holder-data-form
          v-if="tariffType === 'private'"
          ref="policyHolderDataForm"
          editable
          @change="
            () => {
              hasChanged = true
            }
          "
        />

        <dx-business-policy-holder-data-form
          v-else
          ref="businessPolicyHolderDataForm"
          editable
          @change="
            () => {
              hasChanged = true
            }
          "
        />

        <dx-bottom-bar
          :is-sticky="false"
          :show-previous-button="true"
          class="mt-5"
          @back="goBack"
          @forward="goForward"
        />
      </div>
      <div class="col-12 col-md-4 d-none d-md-block">
        <dx-sticky-price-container
          :selected-tariff="activeTariff"
          :price="premia.totalPremium.value"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DxProgressbar from '~/components/DX-Progressbar'
import DxBottomBar from '~/components/DX-BottomBar'
import DxPolicyHolderDataForm from '~/components/offer/DX-PolicyHolderData'
import DxStickyPriceContainer from '~/domains/partnerPortal/components/DX-StickyPriceContainer'
import DxBusinessPolicyHolderDataForm from '~/components/offer/DX-BusinessPolicyHolderData'
import scrollFirstErrorIntoView from '~/javascripts/helper/scollIntoView'

export default {
  name: 'OfferPolicyholderData',
  components: {
    DxProgressbar,
    DxBottomBar,
    DxStickyPriceContainer,
    DxPolicyHolderDataForm,
    DxBusinessPolicyHolderDataForm,
  },
  layout: 'website',
  // maybe use a dynamic layout here some day?
  // layout: ({ store }) => (store.getters.isLoggedIn ? 'default' : 'website'),
  data() {
    return {
      premia: this.$store.state.offer.premia,
      activeTariff: this.$store.state.offer.activeTariff,
    }
  },
  computed: {
    tariffType() {
      return this.$store.getters.GET_ACTIVE_TARIFF_TYPE
    },
    formRef() {
      return this.tariffType === 'private'
        ? 'policyHolderDataForm'
        : 'businessPolicyHolderDataForm'
    },
  },
  methods: {
    goBack() {
      const introPath = this.$store.getters.GET_OFFER_INTRO_PATH
      this.$refs[this.formRef].saveForm(true)
      this.$router.push({ path: this.localePath(introPath) })
    },
    jumpToStep(stepNumber) {
      if (stepNumber === 1) {
        this.goBack()
      }
    },
    async goForward() {
      const valid = await this.$refs[this.formRef].saveForm()
      if (valid) {
        this.$store.commit('SET_STEP', 3)
        this.$router.push({ path: this.localePath('Offer-Questions') })
      } else {
        await scrollFirstErrorIntoView()
      }
    },
  },
  meta: {
    isPublic: true,
    trackingId:
      'dextra.rechtsschutz-antragsstrecke.fragen-zum-versicherungsnehmer',
    offerStep: 2,
  },
  nuxtI18n: {
    paths: {
      de: '/rechtsschutz-antragsstrecke/fragen-zum-versicherungsnehmer/',
      fr:
        '/protection-juridique-formulaire-de-demande/coordonnees-du-preneur-dassurance/',
    },
  },
}
</script>
